import { EmployeesPageProvider } from '@/components/Employees/contexts/EmployeesPageContext';
import { EmployeesInvitesTable } from '@/components/Employees/EmployeesInvitesTable';
import { EmployeesPageHeader } from '@/components/Employees/EmployeesPageHeader';
import { EmployeesTable } from '@/components/Employees/EmployeesTable';
import { CreateEmployeeModal } from '@/components/Modal/CreateEmployeeModal';
import { DeleteEmployeeInvitation } from '@/components/Modal/DeleteEmployeeInvitation';
import { DeleteEmployeeModal } from '@/components/Modal/DeleteEmployeeModal';
import { InviteEmployeeModal } from '@/components/Modal/InviteEmployeeModal';
import { CrudPageStateContextProvider } from '@/context/CrudPageContext';
import React from 'react';

function EmployeesPage() {
  return (
    <CrudPageStateContextProvider>
      <EmployeesPageProvider>
        <EmployeesPageHeader />
        <EmployeesTable />
        <EmployeesInvitesTable />
        <CreateEmployeeModal />
        <DeleteEmployeeModal />
        <InviteEmployeeModal />
        <DeleteEmployeeInvitation />
      </EmployeesPageProvider>
    </CrudPageStateContextProvider>
  );
}

export { EmployeesPage };
